<script setup lang="ts">
/** TMP085 — Section 76 Notice of Approval for Allotment (Secretary sign) + Lodger Information.
 *  실제 변수: company, allotment_date, conditions_text, secretary_*, signature_date, lodger_*.
 *  토글: grant_of_rights(else shares), has_conditions. Signers 없음(비서가 표로 서명). */
import { computed, inject } from 'vue';
import { OTC_DOC_CTX } from './otcContext';
import OtcDocVarField from './OtcDocVarField.vue';

const ctx = inject(OTC_DOC_CTX)!;
const grant = computed(() => ctx.flag('grant_of_rights'));
const hasCond = computed(() => ctx.flag('has_conditions'));
</script>

<template>
  <div class="allot-doc">
    <div class="doc-head">
      <div class="doc-meta">COMPANIES ACT 2016</div>
      <div class="doc-meta" style="font-weight:700">Section 76</div>
      <div class="doc-company" style="font-size:14px">NOTICE OF APPROVAL FOR ALLOTMENT OF SHARES OR GRANT OF RIGHTS</div>
      <div class="doc-company" style="margin-top:6px"><OtcDocVarField field-key="company_name" /></div>
    </div>

    <p class="doc-p">To the Registrar of Companies,</p>
    <p class="doc-p">
      <OtcDocVarField field-key="company_name" /> [Company Registration No.
      <OtcDocVarField field-key="company_registration_no" />] hereby gives notice that on the
      <OtcDocVarField field-key="allotment_date" />, an allotment of
      <span class="doc-toggle" title="grant of rights / shares" @click="ctx.toggleFlag('grant_of_rights')">{{ grant ? 'grant of rights' : 'shares' }}</span>
      has been approved. The approval is
      <span class="doc-toggle" title="conditions?" @click="ctx.toggleFlag('has_conditions')">{{ hasCond ? 'subject to the following conditions:' : 'not subject to any conditions' }}</span>
      <template v-if="hasCond"> <OtcDocVarField field-key="conditions_text" /></template>.
    </p>

    <p class="doc-lbl-title">Declaration:</p>
    <p class="doc-p">I confirm that the facts and information stated in this document are true and to the best of my knowledge.</p>
    <p class="doc-p"><b>Signed:</b> &nbsp; Secretary</p>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Name</td><td><OtcDocVarField field-key="secretary_name" /></td></tr>
        <tr><td class="cdd-lcell">License no / Membership No.</td><td><OtcDocVarField field-key="secretary_license_no" /></td></tr>
        <tr><td class="cdd-lcell">SSM Practicing Certificate No.</td><td><OtcDocVarField field-key="secretary_sspc_no" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td><OtcDocVarField field-key="signature_date" /></td></tr>
      </tbody>
    </table>

    <p class="doc-attn">
      <b>Attention:</b> It is an offence under section 591 of the Companies Act 2016 to make or authorize the making of a statement that a
      person knows is false or misleading and that person may be liable, upon conviction, to imprisonment for a term not exceeding ten years or
      to a fine not exceeding RM3million or to both.
    </p>

    <p class="doc-lbl-title">LODGER INFORMATION</p>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Name</td><td><OtcDocVarField field-key="lodger_name" /></td></tr>
        <tr><td class="cdd-lcell">NRIC No</td><td><OtcDocVarField field-key="lodger_nric" /></td></tr>
        <tr><td class="cdd-lcell">Address</td><td><OtcDocVarField field-key="lodger_address" /></td></tr>
        <tr><td class="cdd-lcell">Phone No</td><td><OtcDocVarField field-key="lodger_phone" /></td></tr>
        <tr><td class="cdd-lcell">Email</td><td><OtcDocVarField field-key="lodger_email" /></td></tr>
      </tbody>
    </table>
  </div>
</template>
